module.exports = __webpack_public_path__ + "img/IMG_1444_L_BlackMatted.9804132b.jpg";